// Клавиша-модификатор в подписях (ux.md, раздел 8; FR-037): на Mac, iPhone и iPad — ⌘, на
// остальных платформах — Ctrl. Обработчики клавиш слушают обе (metaKey или ctrlKey), а подсказки,
// подвал окна и список клавиш показывают ту, что есть на клавиатуре человека.

export type ModKey = '⌘' | 'Ctrl';
export type AltKey = '⌥' | 'Alt';

/** То, что браузер сообщает о платформе; userAgentData есть не во всех браузерах. */
export interface PlatformHints {
  platform?: string;
  userAgent?: string;
  userAgentData?: { platform?: string };
}

const APPLE = /mac|iphone|ipad|ipod/i;

/** Mac, iPhone, iPad: «macOS», «MacIntel», «iPhone» — или «Macintosh» в строке браузера. */
export function isApplePlatform(
  // Вне браузера (сборка, Node без navigator) платформы нет — подписи с Ctrl.
  hints: PlatformHints | undefined = globalThis.navigator,
): boolean {
  if (!hints) return false;
  const platform = hints.userAgentData?.platform || hints.platform || hints.userAgent || '';
  return APPLE.test(platform);
}

/** Клавиша-модификатор: «⌘» на Mac, «Ctrl» на остальных. */
export function modKey(): ModKey {
  return isApplePlatform() ? '⌘' : 'Ctrl';
}

/** Сочетание одной надписью: «⌘K» на Mac, «Ctrl+K» на остальных. */
export function modShortcut(key: string): string {
  return isApplePlatform() ? `⌘${key}` : `Ctrl+${key}`;
}

/** Клавиша Alt: на клавиатуре Mac она подписана «⌥» (Option). */
export function altKey(): AltKey {
  return isApplePlatform() ? '⌥' : 'Alt';
}

/** Сочетание с Alt одной надписью: «⌥↓» на Mac, «Alt+↓» на остальных. */
export function altShortcut(key: string): string {
  return isApplePlatform() ? `⌥${key}` : `Alt+${key}`;
}
